import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'
import {
	emailSchema,
	maxLengthSchema,
	phoneSchema,
} from '@/utils/fieldSchemas'

import { urlSchema } from '../fieldSchemas'

export const FULL_NAME_MAX_LENGTH = 300

export const getPersonalSchema = (t: TTranslationFunction) =>
	yup
		.object({
			fullName: maxLengthSchema(FULL_NAME_MAX_LENGTH, t).notRequired(),
		})
		.notRequired()

export const getContactSchema = (t: TTranslationFunction) =>
	yup
		.object({
			phone: yup.array(
				yup.object({
					value: phoneSchema(t).notRequired(),
				}),
			),

			website: urlSchema(t, { required: false }),

			email: yup.array(
				yup.object({
					value: emailSchema(t).notRequired(),
				}),
			),
		})
		.required()

export const getContactInfoSchema = (t: TTranslationFunction) => {
	return yup
		.object({
			personal: getPersonalSchema(t),
			contacts: getContactSchema(t),
		})
		.required()
}

export type TContactInfoFormFields = InferType<
	ReturnType<typeof getContactInfoSchema>
>
